import { render, staticRenderFns } from "./ShiftsTopLeftContainer.vue?vue&type=template&id=3cdc63c4&scoped=true&"
import script from "./ShiftsTopLeftContainer.vue?vue&type=script&lang=js&"
export * from "./ShiftsTopLeftContainer.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsTopLeftContainer.vue?vue&type=style&index=0&id=3cdc63c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc63c4",
  null
  
)

export default component.exports